import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { Logger } from '@gci/helpers/logger';
import { AuthService } from 'app/core/auth/auth.service';
import { environment } from 'environments/environment';
import { of, switchMap } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (
    route,
    state
) => {
    const router: Router = inject(Router);
    const logger = new Logger('NoAuthGuard');

    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                const language = route.queryParamMap.get("lang");
                let langParam = '';
                if (language) {
                    langParam = `?lang=${language}`;
                }

                logger.debug("langParam", langParam, state.url);

                // If the user is authenticated...
                if (authenticated) {
                    // Redirect to main dashboard
                    const urlTree = router.parseUrl(`signed-in-redirect${langParam}`);
                    logger.debug("state.url", state.url, "urlTree", urlTree);

                    return of(urlTree);
                }

                // Allow the access
                return of(true);
            })
        );
};
